import React from 'react';

import { useScrollToLocationForReference } from 'src/editor';
import type { SelectedReference } from 'src/editor/toolbars/right-panel/ai/extraction/reports/ExtractionJobDetail';
import { openDocumentQuestion } from 'src/helpers';
import { useMaybeEditor } from 'src/layout-engine';

import type { MarkdownComponentProps } from '../../chat/ChatPanelMarkdown/ChatPanelMarkdown';
import { Citation } from '../../shared/components/Citation';

interface ExtractionQuestionCitationProps {
  documentId: string;
  questionId: string;
  reference: SelectedReference;
}

/**
 * Container component specifically for extraction job citations. This component
 * handles the business logic for extraction question citations, then renders
 * the presentational Citation component.
 */
export function ExtractionQuestionCitation({
  documentId,
  questionId,
  reference,
  ...rest
}: ExtractionQuestionCitationProps & MarkdownComponentProps<HTMLAnchorElement>): JSX.Element {
  const editor = useMaybeEditor();
  const { scrollToLocationForReference } = useScrollToLocationForReference();

  const handleClickCitation = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (!editor) {
      openDocumentQuestion({ documentId, questionId });
      return;
    }

    // If we are in an editor context, just scroll to the reference.
    scrollToLocationForReference({ aiReference: reference });
  };

  return <Citation onClickCitation={handleClickCitation} {...rest} />;
}
